<template>
	<div class="header1">
	  <el-button type="primary" :class="type?'buttonC':'buttonD'"  @click="clickButton(true)">
		  <div style="width:10%;float: left;"><img src="@/assets/images/svg/101.svg" /></div>
		  <div style="width:90%;float: left;text-align: center;font-size: 14px;">发行相关</div>
	   </el-button>
	  <el-button type="primary" :class="type?'buttonD':'buttonC'" @click="clickButton(false)">
		  <div style="width:10%;float: left;"><img src="@/assets/images/svg/100.svg" /></div>
		  <div style="width:90%;float: left;text-align: center;font-size: 14px;">侵权反馈</div>
	   </el-button>
	   
	   <Form1 v-if="type"></Form1>
	   <Form2 v-if="! type"></Form2>
	</div>
</template>

<script>
import Form1 from './Form1.vue'	
import Form2 from './Form2.vue'	
	
export default {
  name: 'ConFooter',
  components:{Form1,Form2},
  
  data() {
	return{
		type:true,
	}
  },
  methods:{
	  clickButton(type){
		  this.type = type
	  }
  }
}
</script>

<style scoped>
	
	.header1{
		margin-top:80px;
		width:60%;
		margin-left:20%;
		font-size: 12px;
		padding-bottom: 30px;
	}
	img{
		width: 14px;
		height: 14px;
	}
	.buttonC{
		background-color: #282424;
		width: 350px;
		height: 36px;
		cursor:pointer;
		margin: 0 20px 0 20px;
	}
	.buttonD{
		background-color: #b1b1b1;
		width: 350px;
		height: 36px;
		cursor:pointer;
		margin: 0 20px 0 20px;
	}
	.header1 div{
		cursor:pointer;
	}
</style>